'use client';

import React from 'react';
import AnchorLink from '@/components/TableOfContents/AnchorLink';
import BrandLogo from '@/components/BrandLogo/BrandLogo';
import ContentfulRichText from '@/components/ContentfulRichText/ContentfulRichText';
import AnimatedLink from '@/components/AnimatedLink/AnimatedLink';
import { analytics } from '@/utils/analytics';
import { BrandType, DescriptionType, ImageType } from '@/utils/common.types';

interface Props {
  title: string;
  description: DescriptionType;
  image: {
    desktop: ImageType;
    mobile: ImageType;
  };
  buttonUrl: string;
  buttonOpenNewWindow: boolean;
  brand?: BrandType;
  includeSegment?: boolean;
  anchorTagRef?: string;
}

const FullWidthFeatureCard = ({
  title,
  description,
  image,
  buttonUrl,
  buttonOpenNewWindow,
  brand,
  includeSegment = false,
  anchorTagRef = '',
}: Props) => {
  return (
    <section
      className="h-[560px] bg-cover bg-center bg-no-repeat font-source-sans"
      style={{
        backgroundImage:
          image?.desktop?.url && `url('${image?.desktop?.url}?fm=webp')`,
      }}
    >
      {anchorTagRef && <AnchorLink anchorTagRef={anchorTagRef} />}
      <section
        className="h-full scroll-m-standard"
        id={anchorTagRef && `anchortag-${anchorTagRef}`}
      >
        <div className="flex h-full flex-col justify-center bg-[#00000099] px-[35px] pl-5 pr-[15px] md:px-32 md:pb-[29px] smDesktop:pl-[90px] smDesktop:pr-[385px] mdDesktop:pl-[60px] mdDesktop:pr-[660px] lgDesktop:pl-[86px] lgDesktop:pr-[798px]">
          {brand && <BrandLogo brand={brand} />}
          <div className="">
            <div className="text-[18px] text-white [&_p]:leading-[26px] [&_p]:lgMobile:leading-[29px]">
              {description && ContentfulRichText(description)}
            </div>
            {buttonUrl && (
              <AnimatedLink
                title={title}
                buttonUrl={buttonUrl}
                buttonOpenNewWindow={buttonOpenNewWindow}
                onClick={() =>
                  includeSegment &&
                  analytics?.track('CTA Clicked', {
                    isNav: true,
                    type: 'text',
                    text: title,
                  })
                }
                paddingTop="20"
                className="text-[18px] font-bold leading-[22px] text-white"
              />
            )}
          </div>
        </div>
      </section>
    </section>
  );
};

export default FullWidthFeatureCard;
